/**
 * @generated SignedSource<<ad5f6ea73ec095e8719910cbed2348a0>>
 * @relayHash e356fa116b4c60c1a27e879c4021d428
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/535.0.0-2025-11-04T15:40:23.188Z/NftProfileCollectionQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileCollectionQuery$variables = {
  collectionCursor?: string | null;
  collectionFirst?: number | null;
  creationsCursor?: string | null;
  creationsFirst?: number | null;
  draftsCursor?: string | null;
  draftsFirst?: number | null;
  fetchDrafts: boolean;
  fetchUser: boolean;
  hasTokenContractId: boolean;
  liveAuctionsCursor?: string | null;
  liveAuctionsFirst?: number | null;
  liveBidsCursor?: string | null;
  liveBidsFirst?: number | null;
  lostBidsCursor?: string | null;
  lostBidsFirst?: number | null;
  tokenContractId: string;
  userId: string;
  username: string;
  walletAddress?: string | null;
};
export type NftProfileCollectionQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"NftProfileCollection_viewer">;
  };
};
export type NftProfileCollectionQuery = {
  response: NftProfileCollectionQuery$data;
  variables: NftProfileCollectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "creationsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "creationsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "draftsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "draftsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchDrafts"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasTokenContractId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "liveAuctionsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "liveAuctionsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "liveBidsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "liveBidsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lostBidsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lostBidsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tokenContractId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "walletAddress"
  }
],
v1 = {
  "items": [
    {
      "kind": "Variable",
      "name": "creatorAddresses.0",
      "variableName": "walletAddress"
    }
  ],
  "kind": "ListValue",
  "name": "creatorAddresses"
},
v2 = {
  "items": [
    {
      "kind": "Variable",
      "name": "creatorProfileUsernames.0",
      "variableName": "username"
    }
  ],
  "kind": "ListValue",
  "name": "creatorProfileUsernames"
},
v3 = {
  "kind": "Literal",
  "name": "onlyFirstdibsContracts",
  "value": true
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "kind": "Literal",
  "name": "excludeOwnerCreatedItems",
  "value": true
},
v7 = {
  "items": [
    {
      "kind": "Variable",
      "name": "ownerAddresses.0",
      "variableName": "walletAddress"
    }
  ],
  "kind": "ListValue",
  "name": "ownerAddresses"
},
v8 = {
  "items": [
    {
      "kind": "Variable",
      "name": "ownerProfileUsernames.0",
      "variableName": "username"
    }
  ],
  "kind": "ListValue",
  "name": "ownerProfileUsernames"
},
v9 = {
  "items": [
    {
      "kind": "Variable",
      "name": "auctionSellerAddresses.0",
      "variableName": "walletAddress"
    }
  ],
  "kind": "ListValue",
  "name": "auctionSellerAddresses"
},
v10 = {
  "items": [
    {
      "kind": "Variable",
      "name": "auctionSellerProfileUsernames.0",
      "variableName": "username"
    }
  ],
  "kind": "ListValue",
  "name": "auctionSellerProfileUsernames"
},
v11 = {
  "kind": "Variable",
  "name": "bidderAddress",
  "variableName": "walletAddress"
},
v12 = {
  "kind": "Literal",
  "name": "status",
  "value": "BIDDER_LIVE"
},
v13 = {
  "kind": "Variable",
  "name": "username",
  "variableName": "username"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = [
  (v14/*: any*/)
],
v16 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftAuctionsByBidderEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v15/*: any*/),
    "storageKey": null
  }
],
v17 = {
  "kind": "Literal",
  "name": "status",
  "value": "BIDDER_LOST"
},
v18 = {
  "kind": "Variable",
  "name": "creatorAddress",
  "variableName": "walletAddress"
},
v19 = [
  (v18/*: any*/),
  (v13/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importStatus",
  "storageKey": null
},
v22 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_ERROR"
  ]
},
v23 = {
  "alias": "errored",
  "args": [
    (v22/*: any*/)
  ],
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
},
v24 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_PROCESSING"
  ]
},
v25 = {
  "alias": "processing",
  "args": [
    (v24/*: any*/)
  ],
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
},
v26 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_COMPLETE"
  ]
},
v27 = [
  (v26/*: any*/)
],
v28 = {
  "alias": "completed",
  "args": (v27/*: any*/),
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collectionName",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v32 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "collectionCursor"
  },
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "collectionFirst"
  },
  (v7/*: any*/),
  (v8/*: any*/)
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v31/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NftDigitalArtMetadataMedia",
          "kind": "LinkedField",
          "name": "media",
          "plural": false,
          "selections": [
            (v33/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "posterFrameUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "videoThumb",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "edition",
          "storageKey": null
        }
      ],
      "type": "NftDigitalArtMetadata",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v35 = [
  {
    "kind": "Literal",
    "name": "excludeCanceled",
    "value": true
  }
],
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v37 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ether",
    "storageKey": null
  }
],
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherAmount",
  "kind": "LinkedField",
  "name": "currentBid",
  "plural": false,
  "selections": (v37/*: any*/),
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherAmount",
  "kind": "LinkedField",
  "name": "reservePrice",
  "plural": false,
  "selections": (v37/*: any*/),
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileName",
      "storageKey": null
    },
    (v29/*: any*/)
  ],
  "storageKey": null
},
v42 = [
  (v40/*: any*/),
  (v41/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ensDomain",
    "storageKey": null
  },
  (v29/*: any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "winnerAddress",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v45 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  }
],
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherRates",
  "kind": "LinkedField",
  "name": "etherRates",
  "plural": true,
  "selections": (v45/*: any*/),
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpUrl",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "NftConversionRateEvent",
  "kind": "LinkedField",
  "name": "endedConversionRates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherRates",
      "kind": "LinkedField",
      "name": "rates",
      "plural": true,
      "selections": (v45/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = [
  (v40/*: any*/),
  (v29/*: any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "creatorAddress",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "sellerAddress",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": (v35/*: any*/),
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "mostRecentAuction",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v38/*: any*/),
    (v39/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NftItem",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        (v46/*: any*/),
        (v29/*: any*/),
        (v47/*: any*/)
      ],
      "storageKey": null
    },
    (v48/*: any*/),
    (v50/*: any*/),
    (v51/*: any*/),
    (v29/*: any*/)
  ],
  "storageKey": "mostRecentAuction(excludeCanceled:true)"
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wasBurned",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importErrorReason",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "NftItemLikes",
  "kind": "LinkedField",
  "name": "likes",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "likeCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicProfileUrl",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "creatorAddress",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    (v41/*: any*/),
    (v29/*: any*/),
    (v40/*: any*/)
  ],
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalSupply",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isERC1155",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "ownerAddress",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenId",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenUri",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "NftTokenContract",
  "kind": "LinkedField",
  "name": "contract",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v29/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "addressWithFields",
      "plural": false,
      "selections": (v49/*: any*/),
      "storageKey": null
    },
    (v40/*: any*/)
  ],
  "storageKey": null
},
v65 = {
  "condition": "fetchUser",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "NftItemBalance",
      "kind": "LinkedField",
      "name": "balanceForUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "balance",
          "storageKey": null
        },
        (v29/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "ownerAddress",
          "plural": false,
          "selections": (v49/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "contractAddress",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": null
},
v67 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "auctionId",
    "storageKey": null
  },
  (v36/*: any*/),
  (v66/*: any*/),
  (v29/*: any*/)
],
v68 = {
  "alias": "recentAuction",
  "args": (v35/*: any*/),
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "mostRecentAuction",
  "plural": false,
  "selections": (v67/*: any*/),
  "storageKey": "mostRecentAuction(excludeCanceled:true)"
},
v69 = {
  "alias": "auction",
  "args": (v35/*: any*/),
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "mostRecentAuction",
  "plural": false,
  "selections": (v67/*: any*/),
  "storageKey": "mostRecentAuction(excludeCanceled:true)"
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v72 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftItemSearchEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v34/*: any*/),
          (v52/*: any*/),
          (v53/*: any*/),
          (v54/*: any*/),
          (v55/*: any*/),
          (v29/*: any*/),
          (v56/*: any*/),
          (v58/*: any*/),
          (v59/*: any*/),
          (v60/*: any*/),
          (v61/*: any*/),
          (v62/*: any*/),
          (v63/*: any*/),
          (v64/*: any*/),
          (v65/*: any*/),
          (v68/*: any*/),
          (v47/*: any*/),
          (v69/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      (v70/*: any*/)
    ],
    "storageKey": null
  },
  (v71/*: any*/)
],
v73 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "liveAuctionsCursor"
  },
  (v9/*: any*/),
  (v10/*: any*/),
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "liveAuctionsFirst"
  }
],
v74 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "creationsCursor"
  },
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "creationsFirst"
  },
  (v3/*: any*/)
],
v75 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "liveBidsCursor"
  },
  (v11/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "liveBidsFirst"
  },
  (v12/*: any*/),
  (v13/*: any*/)
],
v76 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftAuctionsByBidderEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftAuctionBidderRef",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bidDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EtherAmount",
            "kind": "LinkedField",
            "name": "bidAmount",
            "plural": false,
            "selections": (v37/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EthereumAddressType",
            "kind": "LinkedField",
            "name": "bidderAddress",
            "plural": false,
            "selections": (v49/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NftAuction",
            "kind": "LinkedField",
            "name": "auction",
            "plural": false,
            "selections": [
              (v44/*: any*/),
              (v29/*: any*/),
              (v36/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v43/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftItem",
                "kind": "LinkedField",
                "name": "item",
                "plural": false,
                "selections": [
                  (v46/*: any*/),
                  (v29/*: any*/),
                  (v47/*: any*/),
                  (v20/*: any*/),
                  (v34/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v58/*: any*/),
                  (v59/*: any*/),
                  (v60/*: any*/),
                  (v61/*: any*/),
                  (v62/*: any*/),
                  (v63/*: any*/),
                  (v64/*: any*/),
                  (v65/*: any*/),
                  (v68/*: any*/),
                  (v69/*: any*/)
                ],
                "storageKey": null
              },
              (v48/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/)
            ],
            "storageKey": null
          },
          (v29/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      (v70/*: any*/)
    ],
    "storageKey": null
  },
  (v71/*: any*/)
],
v77 = [
  "username",
  "bidderAddress",
  "status"
],
v78 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "lostBidsCursor"
  },
  (v11/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "lostBidsFirst"
  },
  (v17/*: any*/),
  (v13/*: any*/)
],
v79 = [
  {
    "kind": "Variable",
    "name": "tokenContractId",
    "variableName": "tokenContractId"
  }
],
v80 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "draftsCursor"
  },
  (v18/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "draftsFirst"
  },
  (v13/*: any*/)
],
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalUrl",
  "storageKey": null
},
v82 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v83 = [
  (v82/*: any*/),
  (v22/*: any*/)
],
v84 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "NftTokenContractImportCreatedItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v55/*: any*/),
          (v34/*: any*/),
          (v52/*: any*/),
          (v53/*: any*/),
          (v54/*: any*/),
          (v29/*: any*/),
          (v56/*: any*/),
          (v58/*: any*/),
          (v59/*: any*/),
          (v60/*: any*/),
          (v61/*: any*/),
          (v62/*: any*/),
          (v63/*: any*/),
          (v64/*: any*/),
          (v65/*: any*/),
          (v68/*: any*/),
          (v47/*: any*/),
          (v69/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      (v70/*: any*/)
    ],
    "storageKey": null
  },
  (v71/*: any*/)
],
v85 = [
  "importStatuses"
],
v86 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v87 = [
  (v86/*: any*/),
  (v22/*: any*/)
],
v88 = [
  (v82/*: any*/),
  {
    "kind": "Literal",
    "name": "importStatuses",
    "value": [
      "NFT_ITEM_IMPORT_STATUS_COMPLETE",
      "NFT_ITEM_IMPORT_STATUS_PROCESSING"
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftProfileCollectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftProfileCollection_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NftProfileCollectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "nftBenignNeglect",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftBenignNeglect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
          },
          {
            "alias": "creations",
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": "collection",
            "args": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": "liveAuctions",
            "args": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v6/*: any*/)
            ],
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": "liveBids",
            "args": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "concreteType": "NftAuctionsByBidderConnection",
            "kind": "LinkedField",
            "name": "nftAuctionsByBidder",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": "lostBids",
            "args": [
              (v11/*: any*/),
              (v17/*: any*/),
              (v13/*: any*/)
            ],
            "concreteType": "NftAuctionsByBidderConnection",
            "kind": "LinkedField",
            "name": "nftAuctionsByBidder",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": "tokenImports",
            "args": (v19/*: any*/),
            "concreteType": "NftTokenContractImportsConnection",
            "kind": "LinkedField",
            "name": "nftTokenContractImports",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContractImportsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContractImport",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v23/*: any*/),
                      (v25/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "collection",
                    "args": null,
                    "concreteType": "NftTokenContractImport",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      {
                        "alias": "incompleteItems",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "importStatuses",
                            "value": [
                              "NFT_ITEM_IMPORT_STATUS_ERROR",
                              "NFT_ITEM_IMPORT_STATUS_PROCESSING"
                            ]
                          }
                        ],
                        "concreteType": "NftTokenContractImportCreatedItemsConnection",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                      },
                      (v21/*: any*/),
                      (v23/*: any*/),
                      (v25/*: any*/),
                      (v28/*: any*/),
                      (v30/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftTokenContract",
                        "kind": "LinkedField",
                        "name": "contract",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 4
                          },
                          {
                            "kind": "Literal",
                            "name": "importStatuses",
                            "value": [
                              "NFT_ITEM_IMPORT_STATUS_COMPLETE",
                              "NFT_ITEM_IMPORT_STATUS_PROCESSING",
                              "NFT_ITEM_IMPORT_STATUS_ERROR"
                            ]
                          }
                        ],
                        "concreteType": "NftTokenContractImportCreatedItemsConnection",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftTokenContractImportCreatedItemsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftItem",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "NftDigitalArtMetadataMedia",
                                            "kind": "LinkedField",
                                            "name": "media",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": "poster",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "posterFrameUrl",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": "web",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "webUrl",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "NftDigitalArtMetadata",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v29/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "items(first:4,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\",\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                      },
                      {
                        "alias": "completeItems",
                        "args": (v27/*: any*/),
                        "concreteType": "NftTokenContractImportCreatedItemsConnection",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
                      },
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v29/*: any*/),
          {
            "alias": "walletConnectFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "allowWalletConnect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "alias": "isNftAuctionV2Enabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftAuctionV2"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
          },
          {
            "alias": null,
            "args": (v32/*: any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v72/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v32/*: any*/),
            "filters": [
              "ownerProfileUsernames",
              "ownerAddresses",
              "excludeOwnerCreatedItems"
            ],
            "handle": "connection",
            "key": "NftProfileSectionCollection_nftItemSearch",
            "kind": "LinkedHandle",
            "name": "nftItemSearch"
          },
          {
            "alias": "nftsForSale",
            "args": (v73/*: any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v72/*: any*/),
            "storageKey": null
          },
          {
            "alias": "nftsForSale",
            "args": (v73/*: any*/),
            "filters": [
              "auctionSellerProfileUsernames",
              "auctionSellerAddresses",
              "excludeOwnerCreatedItems"
            ],
            "handle": "connection",
            "key": "NftProfileSectionAuctions_nftsForSale",
            "kind": "LinkedHandle",
            "name": "nftItemSearch"
          },
          {
            "alias": "nftCreations",
            "args": (v74/*: any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v72/*: any*/),
            "storageKey": null
          },
          {
            "alias": "nftCreations",
            "args": (v74/*: any*/),
            "filters": [
              "creatorProfileUsernames",
              "creatorAddresses",
              "onlyFirstdibsContracts"
            ],
            "handle": "connection",
            "key": "NftProfileSectionCreations_nftCreations",
            "kind": "LinkedHandle",
            "name": "nftItemSearch"
          },
          {
            "alias": "bidderLiveBids",
            "args": (v75/*: any*/),
            "concreteType": "NftAuctionsByBidderConnection",
            "kind": "LinkedField",
            "name": "nftAuctionsByBidder",
            "plural": false,
            "selections": (v76/*: any*/),
            "storageKey": null
          },
          {
            "alias": "bidderLiveBids",
            "args": (v75/*: any*/),
            "filters": (v77/*: any*/),
            "handle": "connection",
            "key": "NftProfileSectionLiveBids_bidderLiveBids",
            "kind": "LinkedHandle",
            "name": "nftAuctionsByBidder"
          },
          {
            "alias": "bidderLostBids",
            "args": (v78/*: any*/),
            "concreteType": "NftAuctionsByBidderConnection",
            "kind": "LinkedField",
            "name": "nftAuctionsByBidder",
            "plural": false,
            "selections": (v76/*: any*/),
            "storageKey": null
          },
          {
            "alias": "bidderLostBids",
            "args": (v78/*: any*/),
            "filters": (v77/*: any*/),
            "handle": "connection",
            "key": "NftProfileSectionLostBids_bidderLostBids",
            "kind": "LinkedHandle",
            "name": "nftAuctionsByBidder"
          },
          {
            "alias": null,
            "args": [
              (v13/*: any*/)
            ],
            "concreteType": "PublicProfile",
            "kind": "LinkedField",
            "name": "publicProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              (v29/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v79/*: any*/),
            "concreteType": "NftTokenContractImport",
            "kind": "LinkedField",
            "name": "nftTokenContractImportById",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v29/*: any*/)
            ],
            "storageKey": null
          },
          {
            "condition": "fetchDrafts",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "draftItems",
                "args": (v19/*: any*/),
                "concreteType": "NftItemDraftsByCreatorConnection",
                "kind": "LinkedField",
                "name": "nftItemDraftsByCreator",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItemDraftsByCreatorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "drafts",
                "args": (v80/*: any*/),
                "concreteType": "NftItemDraftsByCreatorConnection",
                "kind": "LinkedField",
                "name": "nftItemDraftsByCreator",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItemDraftsByCreatorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftItemDraft",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v31/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "editionNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "editionTotal",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftMedia",
                            "kind": "LinkedField",
                            "name": "mainMedia",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v81/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "videoThumbUrl",
                                "storageKey": null
                              },
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftMedia",
                            "kind": "LinkedField",
                            "name": "posterFrameMedia",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v81/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayUrl",
                                "storageKey": null
                              },
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "modifiedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "ethereumWalletAddress",
                                "plural": false,
                                "selections": [
                                  (v57/*: any*/),
                                  (v29/*: any*/),
                                  (v41/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v29/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v70/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v71/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "drafts",
                "args": (v80/*: any*/),
                "filters": [
                  "username",
                  "creatorAddress"
                ],
                "handle": "connection",
                "key": "NftProfileSectionDrafts_drafts",
                "kind": "LinkedHandle",
                "name": "nftItemDraftsByCreator"
              }
            ]
          },
          {
            "condition": "hasTokenContractId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "nftTokenContractImportErrors",
                "args": (v79/*: any*/),
                "concreteType": "NftTokenContractImport",
                "kind": "LinkedField",
                "name": "nftTokenContractImportById",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v83/*: any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v84/*: any*/),
                    "storageKey": "items(first:20,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": null,
                    "args": (v83/*: any*/),
                    "filters": (v85/*: any*/),
                    "handle": "connection",
                    "key": "NftProfileImportCollectionViewNftList_items",
                    "kind": "LinkedHandle",
                    "name": "items"
                  },
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v79/*: any*/),
                "concreteType": "NftTokenContractImport",
                "kind": "LinkedField",
                "name": "nftTokenContractImportById",
                "plural": false,
                "selections": [
                  {
                    "alias": "errorItems",
                    "args": (v87/*: any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": null,
                    "args": (v88/*: any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v84/*: any*/),
                    "storageKey": "items(first:20,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                  },
                  {
                    "alias": null,
                    "args": (v88/*: any*/),
                    "filters": (v85/*: any*/),
                    "handle": "connection",
                    "key": "NftProfileImportCollectionViewNftList_items",
                    "kind": "LinkedHandle",
                    "name": "items"
                  },
                  (v21/*: any*/),
                  (v66/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectionDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContract",
                    "kind": "LinkedField",
                    "name": "contract",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tokenStandard",
                        "storageKey": null
                      },
                      (v29/*: any*/),
                      (v31/*: any*/),
                      (v40/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "symbol",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "processingItems",
                    "args": [
                      (v86/*: any*/),
                      (v24/*: any*/)
                    ],
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                  },
                  {
                    "alias": "completeItems",
                    "args": [
                      (v86/*: any*/),
                      (v26/*: any*/)
                    ],
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
                  },
                  {
                    "alias": "failedItems",
                    "args": (v87/*: any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": "description",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectionDescription",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/535.0.0-2025-11-04T15:40:23.188Z/NftProfileCollectionQuery",
    "metadata": {},
    "name": "NftProfileCollectionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "da62b1df8b8aaf0308dbd76c9e5f1827";

export default node;
